import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { User } from "../models/model_user";
import Close from "../assets/images/ic_close.svg";
import IconFb from "../assets/images/ic_fb_white.png";
import IconIns from "../assets/images/ic_ins_white.svg";
import "./component_home_menu_modal.less";
import { module_chat } from "../models/model_chat";
import { router_homepage_about } from "../utils/enum";
import { LOGOS, partnersUrl, TRIMM_URL } from "../utils/constants";
import { Link } from "react-router-dom";
import { facebookUrl, instagramUrl } from "../utils/constants";
import {
  ModelNotifications,
  module_notifications,
} from "./../models/model_notifications";
import { HashLink } from "react-router-hash-link";
import { mapProp } from "module-reaction";
import { router_get_started } from "../utils/enum";
import IconArrow from "../assets/images/ic_arrow_down.svg";
import { getOptimizedPath } from "../utils/utils";
import { COMMUNITY_NAV_URL, UserCanvasFlags } from "../utils/userNavCanvas";
import {
  AvatarMenuItem,
  buildAdminMenuItems,
  buildAvatarMenuItems,
  getMobilePersonaSubtitle,
  getUserInitials,
} from "../utils/headerUserMenu";

interface Props extends ModelNotifications {
  className?: string;
  visible?: boolean;
  history?: any;
  onLogout?: Function;
  isLogin?: boolean;
  onLogin?: Function;
  onClose: Function;
  user?: User;
  unreadCount?: number;
  onPostOpportunityClick?: Function;
  userCanvasFlags?: UserCanvasFlags;
}

const HomeMenuModal: React.FC<Props> = (props) => {
  const {
    className,
    visible,
    onClose,
    isLogin = false,
    history,
    user,
    onLogout,
    onLogin,
    notificationCount,
    unreadCount = 0,
    onPostOpportunityClick,
    userCanvasFlags = {
      hasSchoolCanvas: false,
      hasBusinessCanvas: false,
      hasPersonalCanvas: false,
      hasStudentCanvas: false,
      hasApplications: false,
    },
  } = props;
  const [isSolutionsActive, setIsSolutionsActive] = useState(false);
  const [isOppActive, setIsOppActive] = useState(false);
  const [isPortActive, setIsPortActive] = useState(false);
  const [isResActive, setIsResActive] = useState(false);

  useEffect(() => {
    if (isSolutionsActive) {
      setIsOppActive(false);
      setIsPortActive(false);
      setIsResActive(false);
    }
  }, [isSolutionsActive]);
  useEffect(() => {
    if (isOppActive) {
      setIsSolutionsActive(false);
      setIsPortActive(false);
      setIsResActive(false);
    }
  }, [isOppActive]);
  useEffect(() => {
    if (isPortActive) {
      setIsSolutionsActive(false);
      setIsOppActive(false);
      setIsResActive(false);
    }
  }, [isPortActive]);
  useEffect(() => {
    if (isResActive) {
      setIsSolutionsActive(false);
      setIsOppActive(false);
      setIsPortActive(false);
    }
  }, [isResActive]);

  function checkLoginThenGo(location: string) {
    const url = isLogin ? location : router_get_started;
    if (url.startsWith("http")) {
      window.location.href = url;
    } else {
      history.push(url);
    }
  }

  const navigateMenuItem = (item: AvatarMenuItem) => {
    if (item.onClick) {
      item.onClick();
      onClose();
      return;
    }
    if (!item.href) {
      return;
    }
    const nextBase = process.env.REACT_APP_NEXT_URL || "";
    if (item.href.startsWith("http") || (nextBase && item.href.startsWith(nextBase))) {
      window.location.href = item.href;
    } else {
      history.push(item.href);
    }
    onClose();
  };

  const renderLoggedOutNav = () => (
    <>
      <button
        className="accordian-btn"
        onClick={() => {
          window.location.href = TRIMM_URL;
        }}
      >
        The Trimm (Newsletter)
      </button>
      <button
        className="accordian-btn"
        id="solutions"
        onClick={() => setIsSolutionsActive(!isSolutionsActive)}
      >
        Solutions
        <img
          src={IconArrow}
          alt=""
          className={isSolutionsActive ? "arrow" : "arrow rotate"}
        />
      </button>
      {isSolutionsActive && (
        <div className="panel">
          <span
            onClick={() => {
              window.location.href = `${process.env.REACT_APP_NEXT_URL}/exclusive-salon-offer`;
            }}
          >
            Salon Hiring
          </span>
          <span
            onClick={() => {
              window.location.href = `${process.env.REACT_APP_NEXT_URL}/brands`;
            }}
          >
            Brand Marketing
          </span>
          <span
            onClick={() => {
              window.location.href = `${process.env.REACT_APP_NEXT_URL}/lp/school`;
            }}
          >
            School Marketing & Placement
          </span>
        </div>
      )}
      <button
        className="accordian-btn"
        id="opportunities"
        onClick={() => setIsOppActive(!isOppActive)}
      >
        Opportunities
        <img
          src={IconArrow}
          alt=""
          className={isOppActive ? "arrow" : "arrow rotate"}
        />
      </button>
      {isOppActive && (
        <div className="panel">
          <span
            onClick={() => {
              checkLoginThenGo(`${process.env.REACT_APP_NEXT_URL}/opportunities`);
              onClose();
            }}
          >
            View Opportunities
          </span>
          <span
            onClick={() => {
              onPostOpportunityClick && onPostOpportunityClick();
              onClose();
            }}
          >
            Create Opportunity
          </span>
        </div>
      )}
      <button
        className="accordian-btn"
        id="portfolios"
        onClick={() => setIsPortActive(!isPortActive)}
      >
        Portfolios
        <img
          src={IconArrow}
          alt=""
          className={isPortActive ? "arrow" : "arrow rotate"}
        />
      </button>
      {isPortActive && (
        <div className="panel">
          {!isLogin && (
            <span
              onClick={() => {
                checkLoginThenGo("/add-canvas");
                onClose();
              }}
            >
              Create a Portfolio
            </span>
          )}
          <span
            onClick={() => {
              checkLoginThenGo("/homepage-canvas/professional");
              onClose();
            }}
          >
            Professional Portfolios
          </span>
          <span
            onClick={() => {
              checkLoginThenGo("/homepage-canvas/business");
              onClose();
            }}
          >
            Business Portfolios
          </span>
          <span
            onClick={() => {
              checkLoginThenGo("/homepage-canvas/school");
              onClose();
            }}
          >
            School Portfolios
          </span>
        </div>
      )}
      <button
        className="accordian-btn"
        id="resources"
        onClick={() => setIsResActive(!isResActive)}
      >
        Resources
        <img
          src={IconArrow}
          alt=""
          className={isResActive ? "arrow" : "arrow rotate"}
        />
      </button>
      {isResActive && (
        <div className="panel">
          <HashLink smooth to="/#faq">
            <span>FAQs</span>
          </HashLink>
          <span
            onClick={() => {
              window.location.href = partnersUrl;
            }}
          >
            Partners
          </span>
          <span
            onClick={() => {
              window.location.href = `${process.env.REACT_APP_NEXT_URL}/hiring-grader`;
            }}
          >
            AI Hiring Grader
          </span>
        </div>
      )}
    </>
  );

  const renderLoggedInNav = () => {
    const initials = getUserInitials(user?.profile?.firstName, user?.profile?.lastName);
    const subtitle = getMobilePersonaSubtitle(userCanvasFlags);
    const adminItems = user?.profile?.target === "admin"
      ? buildAdminMenuItems(history)
      : [];
    const menuItems = buildAvatarMenuItems({
      userCanvasFlags,
      onBeautistaConnectClick: () => {
        window.open(COMMUNITY_NAV_URL, "_blank", "noopener,noreferrer");
      },
      onSignOutClick: () => onLogout && onLogout(),
      isAdmin: user?.profile?.target === "admin",
      adminItems,
    });

    return (
      <>
        <div className="mob-profile">
          {user?.profile?.avatar ? (
            <img
              className="mob-profile-avatar"
              alt=""
              src={user.profile.avatar}
            />
          ) : (
            <span className="mob-profile-initials">{initials}</span>
          )}
          <div>
            <div className="mob-profile-name">{user?.profile?.firstName}</div>
            <div className="mob-profile-sub">{subtitle}</div>
          </div>
        </div>
        <button
          className="accordian-btn mob-opps-link"
          onClick={() => {
            window.location.href = `${process.env.REACT_APP_NEXT_URL}/opportunities`;
            onClose();
          }}
        >
          Opportunities
        </button>
        <button
          className="accordian-btn"
          onClick={() => {
            window.location.href = `${process.env.REACT_APP_NEXT_URL}/classes`;
            onClose();
          }}
        >
          Classes
        </button>
        <button
          className="accordian-btn"
          onClick={() => setIsPortActive(!isPortActive)}
        >
          Portfolios
          <img
            src={IconArrow}
            alt=""
            className={isPortActive ? "arrow" : "arrow rotate"}
          />
        </button>
        {isPortActive && (
          <div className="panel">
            <span
              onClick={() => {
                checkLoginThenGo("/homepage-canvas/professional");
                onClose();
              }}
            >
              Professional Portfolios
            </span>
            <span
              onClick={() => {
                checkLoginThenGo("/homepage-canvas/business");
                onClose();
              }}
            >
              Business Portfolios
            </span>
            <span
              onClick={() => {
                checkLoginThenGo("/homepage-canvas/school");
                onClose();
              }}
            >
              School Portfolios
            </span>
          </div>
        )}
        <button
          className="accordian-btn"
          onClick={() => {
            window.location.href = `${process.env.REACT_APP_NEXT_URL}/news`;
            onClose();
          }}
        >
          News
        </button>
        <button
          className="accordian-btn"
          onClick={() => {
            window.location.href = TRIMM_URL;
            onClose();
          }}
        >
          The Trimm (Newsletter)
        </button>
        {menuItems.map((item, index) => {
          if (item.kind === "divider") {
            return <div key={`divider-${index}`} className="nested-divider" />;
          }
          if (item.kind === "sectionLabel") {
            return (
              <span key={`section-${index}`} className="mob-section-label">
                {item.label}
              </span>
            );
          }

          const className = [
            item.addAccount ? "mob-add-account" : "",
            item.danger ? "sign-out" : "",
            (item.label === "Message" && unreadCount > 0) ||
            (item.label === "Notifications" && notificationCount > 0)
              ? "notification-active"
              : "",
          ].filter(Boolean).join(" ");

          if (item.kind === "action") {
            return (
              <span
                key={`action-${index}`}
                className={className}
                onClick={() => navigateMenuItem(item)}
              >
                {item.label}
              </span>
            );
          }

          return (
            <span
              key={`link-${index}`}
              className={className}
              onClick={() => navigateMenuItem(item)}
            >
              {item.label}
              {item.description && (
                <small className="mob-add-account-desc">{item.description}</small>
              )}
            </span>
          );
        })}
      </>
    );
  };

  return (
    <Modal
      footer={null}
      onCancel={() => onClose()}
      visible={visible}
      closable={false}
      className={className}
      centered={true}
      wrapClassName="menu-modal-style"
    >
      <div className="menu-modal">
        <div className="title-sec">
          <a href={process.env.REACT_APP_NEXT_URL}>
            <img
              alt=""
              src={getOptimizedPath(LOGOS.white, 200)}
              className="logo"
            />
          </a>
          <img alt="" src={Close} className="close" onClick={() => onClose()} />
        </div>
        <div className="top-sec">
          {isLogin ? renderLoggedInNav() : renderLoggedOutNav()}
        </div>
        <div className="divider" />
        {!isLogin ? (
          <div className="bottom-sec">
            <span onClick={() => onLogin && onLogin()}>Sign in</span>
            <br />
            <Button
              className="btn-primary-light btn-start-free"
              onClick={() => history.push("/get-started")}
            >
              SIGN UP
            </Button>
          </div>
        ) : null}
        <div className="divider" />
        <div className="footer-sec">
          <div className="left-wrap">
            <Link to={router_homepage_about}>About</Link>
            <span>Contact</span>
          </div>
          <div className="right-wrap">
            <a href={facebookUrl}>
              <img alt="" src={IconFb} />
            </a>
            <a href={instagramUrl}>
              <img alt="" src={IconIns} />
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default mapProp(
  module_notifications,
  "notificationCount"
)(mapProp(module_chat)(HomeMenuModal));
